"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _configuratorCarousel = _interopRequireDefault(require("../styles/configurator-carousel.css"));

var _configuratorCarouselImage = _interopRequireDefault(require("./configurator-carousel-image"));

var _configuratorCarousel2 = require("./configurator-carousel.props/configurator-carousel.propTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _DataUtils = new _mmcDataUtilities["default"](),
    handleNestedProp = _DataUtils.handleNestedProp;

var getArrayWithLastImageBeforeFirst = function getArrayWithLastImageBeforeFirst(items, carouselImagesLength) {
  var lastItem = items.slice(carouselImagesLength - 1);
  return [].concat(lastItem, items.slice(0, carouselImagesLength - 1));
};

var ConfiguratorCarouselImages = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorCarouselImages, _React$Component);

  ConfiguratorCarouselImages.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var propItems = props.items[0];
    var firstImage = handleNestedProp(propItems, 'propItems.image.image');
    var searchImageResult = state.items.find(function (item) {
      return handleNestedProp(item, 'item.image.image') === firstImage && firstImage !== ' ';
    });

    if (props.carouselImagesLength !== props.twoSlidesCarousel && (props.items.length !== state.items.length || searchImageResult === undefined)) {
      return _objectSpread(_objectSpread({}, state), {}, {
        items: getArrayWithLastImageBeforeFirst(props.items, props.carouselImagesLength)
      });
    }

    if (props.items.length !== state.items.length || searchImageResult === undefined) {
      return _objectSpread(_objectSpread({}, state), {}, {
        items: props.items
      });
    }

    return null;
  };

  function ConfiguratorCarouselImages() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      items: []
    };
    _this.placeLastImageBeforeFirst = _this.placeLastImageBeforeFirst.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateItemsState = _this.updateItemsState.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = ConfiguratorCarouselImages.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        carouselImagesLength = _this$props.carouselImagesLength,
        twoSlidesCarousel = _this$props.twoSlidesCarousel;

    if (carouselImagesLength !== twoSlidesCarousel) {
      return this.placeLastImageBeforeFirst();
    }

    return this.updateItemsState();
  };

  _proto.updateItemsState = function updateItemsState() {
    var items = this.props.items;
    this.setState({
      items: items
    });
  } // places last image before first in carousel so user can always slide pictures in left or right
  ;

  _proto.placeLastImageBeforeFirst = function placeLastImageBeforeFirst() {
    var _this$props2 = this.props,
        items = _this$props2.items,
        carouselImagesLength = _this$props2.carouselImagesLength;
    this.setState({
      items: getArrayWithLastImageBeforeFirst(items, carouselImagesLength)
    });
  };

  _proto.noJavascriptRender = function noJavascriptRender() {
    var _this$props3 = this.props,
        sliding = _this$props3.sliding,
        getOrder = _this$props3.getOrder,
        items = _this$props3.items;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.map(function (carouselItem, i) {
      return /*#__PURE__*/_react["default"].createElement(_configuratorCarouselImage["default"], {
        image: handleNestedProp(carouselItem, 'carouselItem.image.image'),
        altText: handleNestedProp(carouselItem, 'carouselItem.image.altText'),
        order: getOrder(i),
        sliding: sliding
      });
    }));
  };

  _proto.render = function render() {
    var _clsx;

    var _this$props4 = this.props,
        sliding = _this$props4.sliding,
        getOrder = _this$props4.getOrder,
        direction = _this$props4.direction,
        carouselImagesLength = _this$props4.carouselImagesLength,
        twoSlidesCarousel = _this$props4.twoSlidesCarousel;
    var items = this.state.items;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
      className: (0, _clsx2["default"])(_configuratorCarousel["default"].carouselImages, (_clsx = {}, _clsx[_configuratorCarousel["default"].sliding] = sliding, _clsx[_configuratorCarousel["default"].prev] = direction === 'prev', _clsx[_configuratorCarousel["default"].singleSlide] = carouselImagesLength === 1, _clsx[_configuratorCarousel["default"].twoSlidesCarousel] = carouselImagesLength === twoSlidesCarousel, _clsx))
    }, items.map(function (carouselItem, i) {
      return /*#__PURE__*/_react["default"].createElement(_configuratorCarouselImage["default"], {
        image: handleNestedProp(carouselItem, 'carouselItem.image.image'),
        altText: handleNestedProp(carouselItem, 'carouselItem.image.altText'),
        order: getOrder(i),
        sliding: sliding
      });
    }), /*#__PURE__*/_react["default"].createElement("noscript", {
      className: _configuratorCarousel["default"].noScript
    }, this.noJavascriptRender())));
  };

  return ConfiguratorCarouselImages;
}(_react["default"].Component);

exports["default"] = ConfiguratorCarouselImages;
ConfiguratorCarouselImages.displayName = 'ConfiguratorCarouselImages';